// src/zone-flags.ts
(window as any).__zone_symbol__UNPATCHED_EVENTS = [
  "scroll",
  "mousemove",
  "pointermove",
  "touchmove",
  "mouseover",
  "mouseout"
];
// Nie patchuj właściwości on* (onmousemove itd.)
(window as any).__Zone_disable_on_property = true;
